import React, { useEffect, useRef, useState } from "react";
import "./Product_vdo_preview.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllCategories } from "../../../features/master/masterSlice";
import { getAllProducts } from "../../../features/products/productsSlice";
import Common_heading_holder from "../../common-components/common_heading_holder/Common_heading_holder";
import { encodeId } from "../../../utils/common";

function Product_vdo_preview() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sectionRef = useRef(null);

  /* ---------------- REDUX DATA ---------------- */
  const productdata = useSelector((state) => state.product.allProducts);
  const products = productdata?.data || [];

  // ✅ FIXED CATEGORY SELECTOR
  const categories = useSelector((state) => state.master.categories) || [];

  /* ---------------- STATE ---------------- */
  const [activeTab, setActiveTab] = useState(null);

  /* ---------------- FETCH CATEGORIES ---------------- */
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  /* ---------------- SET DEFAULT CATEGORY ---------------- */
  useEffect(() => {
    if (categories.length > 0 && !activeTab) {
      const firstCategory = categories[0];
      setActiveTab(firstCategory.id);

      dispatch(getAllProducts({ category_id: firstCategory.id }));
    }
  }, [categories, activeTab, dispatch]);

  /* ---------------- HANDLE TAB CLICK ---------------- */
  const handleTabClick = (catId) => {
    setActiveTab(catId);
    dispatch(getAllProducts({ category_id: catId }));
  };

  /* ---------------- HANDLE SHOP NOW CLICK ---------------- */
  const handleShopNow = (productId, categoryId) => {
    // Navigate to categories page with category_id
    // navigate(`/categories?category_id=${categoryId}`);

    navigate(`/product-details/${encodeId(productId)}`);
  };

  return (
    <div className="Product_vdo_preview" ref={sectionRef}>
      <div className="container-fluid">
        {/* HEADER */}
        <div className="bestseller_header">


          <Common_heading_holder
            heading_text={
              <>
                <span className="black-text">Our </span>
                <br />
                <span className="blue-text">Bestsellers</span>
              </>
            }
          />

         
          <div className="tabs_holder">
            {categories.length > 0 ? (
              categories.map((cat) => (
                <button
                  key={cat.id}
                  className={`tab_btn ${activeTab === cat.id ? "active" : ""}`}
                  onClick={() => handleTabClick(cat.id)}
                >
                  {cat.name}
                </button>
              ))
            ) : (
              <span className="text-white px-3">Loading...</span>
            )}
          </div>
        </div>

        {/* LAYOUT */}
        <div className="bestseller_layout row">
          {/* LEFT SIDE */}
          <div className="col-lg-6 col-md-6 col-12">
            <div className="left_grid">
              {products.slice(0, 2).map((item, index) => (
                <div className="small_card" key={index}>
                  <img
                    src={process.env.REACT_APP_IMG_URL + item?.image}
                    alt={item?.name}
                  />
                  <div className="overlay"></div>
                  <button
                    className="shop_btn"
                    onClick={() => handleShopNow(item?.id, item?.category_id)}
                  >
                    Shop Now
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-6 col-md-6 col-12">
            {products[2] && (
              <div className="big_card">
                <img
                  src={process.env.REACT_APP_IMG_URL + products[2]?.image}
                  alt={products[2]?.name}
                />
                <div className="overlay"></div>
                <button
                  className="shop_btn"
                  onClick={() =>
                    handleShopNow(products[2]?.id, products[2]?.category_id)
                  }
                >
                  Shop Now
                </button>
              </div>
            )}
          </div>
        </div>

        {/* NO DATA */}
        {products.length === 0 && (
          <div className="text-center mt-4">
            <h5>No Products Available</h5>
          </div>
        )}
      </div>
    </div>
  );
}

export default Product_vdo_preview;
